import { FC, useMemo } from 'react';
import cn from 'classnames';
import { ReactComponent as StarPassiveIcon } from 'images/newIcons/starPassive.svg';

import { useAppSelector } from '../../hooks';
import { InterceptionMember } from '../../interfaces/interceptions';
import { interceptionDepartmentsSelector } from '../../store/slices/interception/selectors';
import { Checkbox } from '../ui';

interface InterceptionsMemberCardProps {
  evenIndex?: boolean;
  member: InterceptionMember;
  selectedMembers: InterceptionMember[];
  selectMember: (interceptionMember: InterceptionMember) => void;
  isOpened: boolean;
}

const InterceptionsMemberCard: FC<InterceptionsMemberCardProps> = ({
  evenIndex,
  member,
  selectedMembers,
  selectMember,
  isOpened = false,
}) => {
  const { name, id, department_id } = member;
  const isChecked = Boolean(selectedMembers.find((member) => member.id === id));
  const departments = useAppSelector(interceptionDepartmentsSelector);
  const selectedDepartmentName = useMemo(() => {
    return departments.find((n) => n.id == department_id)?.name;
  }, [department_id, departments]);
  return (
    <div
      className={cn(
        'flex flex-col py-3 px-6 gap-2 justify-center cursor-pointer',
        {
          'bg-dark': evenIndex,
          'bg-light': !evenIndex,
          'border border-solid border-bright_product rounded-[10px]': isOpened,
        }
      )}
    >
      <div className="flex justify-between">
        <div className="flex justify-center items-center gap-2">
          <div className="[&>svg]:hover:!text-dark_product relative top-[2px]">
            <StarPassiveIcon className="text-tpg_light" />
          </div>
          <div className="font-bold">
            {name || 'Абонент'} <span className="text-tpg_base">({id})</span>
          </div>
          {selectedDepartmentName ? (
            <div className="bg-ultrablack py-[2px] px-3 text-sm radius rounded-[5px]">
              {selectedDepartmentName}
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="text-sm">12.02.2025 06:25:24</div>
        <div
          className="flex items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          <Checkbox
            theme="dark"
            isChecked={isChecked}
            lightBorder={true}
            onChange={() => selectMember(member)}
          />
        </div>
      </div>
    </div>
  );
};

export default InterceptionsMemberCard;
